<!-- =========================================================================================
  File Name: UserList.vue
  Description: Integration Users List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      <div class="vx-row p-4" style="float:right!important;">
        <div class="vx-col-12" style="float:right!important;">
          <vs-button color="primary" style="float:right!important;"  type="filled" icon-pack="feather" icon="icon-plus-circle" @click="addIntegrationUserPopUpActive = true">{{ $t('USER_INTEGRATION.add') }}</vs-button>
        </div>
      </div>
      <br><br><br>
      <!-- <ADICIONAR IntegrationUser> -->
      <vs-popup :title="$t('USER_INTEGRATION.addIntegrationUser')" :active.sync="addIntegrationUserPopUpActive">
        <div class="vx-row" id="add-integration-user">
          <div class="vx-col md:w-1/2 w-full mt-2">
            <vs-input :label="$t('USER_INTEGRATION.name')" v-model="addIntegrationUserData.name" class="w-full" type="text" name="integration-user-name"/>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2" @click="onSelectClick">
            <label class="vs-input--label">{{ $t('USER_INTEGRATION.role') }}</label>
            <v-select label="name" :closeOnSelect="true" v-model="addIntegrationUserData.role" :options="rolesOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-full w-full mb-3">
            <vs-input label="AccessToken" v-model="addIntegrationUserData.apiToken" disabled class="w-full" type="text" name="integration-user-token" v-show="addIntegrationUserData.apiToken !== ''"/>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <div id="blank_content" style="height: 1px;" v-show="showBlankContent"></div>
            <vs-button class="ml-auto mt-2" @click="addIntegrationUser">{{ $t('USER_INTEGRATION.sent') }}</vs-button>
          </div>
        </div>
      </vs-popup>
      <!-- </ADICIONAR DASHBOARD> -->
      <!-- <VISUALIZAR DASHOBARD> -->
      <vs-popup :title="$t('USER_INTEGRATION.viewIntegrationUser')" :active.sync="viewIntegrationUserPopUpActive">
        <div class="vx-row" id="view-integration-user">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-2">
            <vs-input :label="$t('USER_INTEGRATION.name')" v-model="viewIntegrationUserData.name" disabled class="w-full" type="text" name="integration-user-name"/>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2">
            <vs-input :label="$t('USER_INTEGRATION.role')" v-if="viewIntegrationUserPopUpActive" v-model="viewIntegrationUserData.role.name" disabled class="w-full" type="text" name="integration-user-role"/>
          </div>
          <div class="vx-col md:w-full w-full mb-3">
            <vs-input label="AccessToken" v-model="viewIntegrationUserData.apiToken" disabled class="w-full" type="text" name="integration-user-token"/>
          </div>
        </div>
      </vs-popup>
      <!-- </VISUALIZAR DASHBOARD> -->
      <!-- <EDITAR DASHBOARD> -->
      <vs-popup :title="$t('USER_INTEGRATION.editIntegrationUser')" :active.sync="editIntegrationUserPopUpActive">
        <div class="vx-row" id="add-dashboard">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-input :label="$t('USER_INTEGRATION.name')" v-model="editIntegrationUserData.name" class="w-full" type="text" name="integration-user-name"/>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3" @click="onSelectEditClick">
            <label class="vs-input--label">{{ $t('USER_INTEGRATION.role') }}:</label>
            <v-select label="name" :closeOnSelect="true" v-model="editIntegrationUserData.role" :options="rolesOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/><br>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <div id="blank_content_edit" style="height: 1px;" v-show="showBlankContentEdit"></div>
            <vs-button class="ml-auto mt-2" @click="updateIntegrationUser">{{ $t('USER_INTEGRATION.sent') }}</vs-button>
          </div>
        </div>
      </vs-popup>
      <!-- </EDITAR DASHBBOARD> -->
      <div class="vx-card p-6">
        <vs-table
          multiple
          v-model="selectedRows"
          :sst="false"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
          pagination
          max-items="10"
          search
          :data="integrationUsers">

            <template slot="header">
                <h3>{{  $t('USER_INTEGRATION.Management') }}</h3>
            </template>

            <template slot="thead">
                <vs-th sort-key="hash">Hash</vs-th>
                <vs-th sort-key="name">{{ $t('USER_INTEGRATION.name') }}</vs-th>
                <vs-th sort-key="description">{{ $t('USER_INTEGRATION.role') }}</vs-th>
                <vs-th sort-key="refreshInterval">{{ $t('USER_INTEGRATION.sessionToken') }}</vs-th>
                <vs-th sort-key="actions">{{ $t('USER_INTEGRATION.actions') }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].hash">
                  {{ data[indextr].hash }}
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].role">
                  {{ data[indextr].role.name }}
                </vs-td>

                <vs-td :data="data[indextr].api_token">
                  {{ data[indextr].api_token }}
                </vs-td>

                <vs-td>
                  <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer" @click="viewIntegrationUserDetail(data[indextr]['hash'])"/>
                  <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="getIntegrationUserDetail(data[indextr]['hash'])"/>
                  <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr]['hash'])"/>
                  <feather-icon icon="RefreshCwIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="confirmRefreshUserToken(data[indextr]['hash'])"/>
                </vs-td>
              </vs-tr>
            </template>
        </vs-table>
      </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { setApplicationLocalStorageItem } from '../../../helpers'
import { performFetch } from '../../../helpers.js'

export default {
  components: {
    vSelect
  },
  data:() => ({
    showBlankContent: false,
    showBlankContentEdit: false,
    moduleInfo: {
      moduleName: ''
    },
    rowHashToDelete: '',
    rowHashToRefresh: '',
    refreshIntervalOptions: [
      {
        value: 30,
        name: '30 segundos'
      },
      {
        value: 60,
        name: '1 minuto'
      },
      {
        value: 300,
        name: '5 minutos'
      }
    ],
    addIntegrationUserPopUpActive: false,
    viewIntegrationUserPopUpActive: false,
    editIntegrationUserPopUpActive: false,

    addIntegrationUserData: {
      name: '',
      role: {},
      apiToken: ''
    },
    editIntegrationUserData: {
      hash: '',
      name: '',
      role: {}
    },
    viewIntegrationUserData: {
      name: '',
      description: '',
      refreshInterval: 0,
      roles: []
    },
    rolesOptions: [],
    allRolesOptions: [],
    selected:[],
    log: [],
    integrationUsers: [],
    tableTitles: [],
    selectedRows: [],
    rowHashToDelete: ''
  }),
  watch: {
    selectedRows (value) {
      // console.log(value)
    },
    'addIntegrationUserData.role'(newValue) {
      document.querySelector('#blank_content').style.height = '1px'
      this.showBlankContent = false
    },
    'editIntegrationUserData.role'(newValue) {
      document.querySelector('#blank_content_edit').style.height = '1px'
      this.showBlankContentEdit = false
    },
    addIntegrationUserPopUpActive(newValue) {
      if(!newValue) {
        this.getIntegrationUsers()
        this.clearAddForm()
      }
    },
    editIntegrationUserPopUpActive(newValue) {
      if(!newValue) {
        this.clearEditForm()
      }
    }
  },
  mounted () {
    document.querySelector('.vx-card').style.backgroundColor = '#fff'
    document.title = `${document.title.split(' | ')[0]  } | Usuários de Integração`
  },
  methods:{
    onSelectClick() {

      if(!this.showBlankContent) {

        try{
          const offsetHeight = document.querySelector('.vs__dropdown-menu').offsetHeight

          document.querySelector('#blank_content').style.height = offsetHeight + 'px'

          this.showBlankContent = true
        } catch(e) {
          //
        }
      }
    },
    onSelectEditClick() {

      if(!this.showBlankContentEdit) {

        try{
          const offsetHeight = document.querySelector('.vs__dropdown-menu').offsetHeight

          document.querySelector('#blank_content_edit').style.height = offsetHeight + 'px'

          this.showBlankContentEdit = true
        } catch(e) {
          //
        }
      }
    },
    handleSearch (searching) {
      console.log(`The user searched for: ${searching}`)
    },
    handleChangePage (page) {
      console.log(`The user changed the page to: ${page}`)
    },
    handleSort (key, active) {
      console.log(`the user ordered: ${key} ${active}`)
    },
    clearAddForm() {
      this.addIntegrationUserData.name = ''
      this.addIntegrationUserData.role = {}
    },
    clearEditForm() {
      this.editIntegrationUserData.name = ''
      this.editIntegrationUserData.role = {}
    },
    validateAddForm() {
      if(this.addIntegrationUserData.name === '' || this.addIntegrationUserData.name === null) {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if(JSON.stringify(this.addIntegrationUserData.role) === '{}') {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.role') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    validateEditForm() {
      if(this.editIntegrationUserData.name === '' || this.editIntegrationUserData.name === null) {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if(JSON.stringify(this.editIntegrationUserData.role) === '{}') {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.role') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    async confirmRefreshUserToken(rowHash) {
      this.rowHashToRefresh = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: this.$t('USER_INTEGRATION.confirmReset'),
        text: this.$t('USER_INTEGRATION.resetTokenConfirmation'),
        accept: this.refreshUserToken,
        acceptText: this.$t('USER_INTEGRATION.reset')
      })

    },
    async refreshUserToken() {

      this.$vs.loading({ type: 'default' })

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'refresh_application_integration_user_token',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user_hash: this.rowHashToRefresh
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'refresh_application_integration_user_token',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user_hash: this.rowHashToRefresh
          }
        })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.getIntegrationUsers()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.operationPerformed'),
                text: this.$t('USER_INTEGRATION.tokenUpdated'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToRefresh = ''

    },
    async addIntegrationUser() {

      if(!this.validateAddForm()) {
        return
      }

      this.$vs.loading({type: 'default'})

      let dashboardRoles = []

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'add_application_integration_user',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user: {
      //         name: this.addIntegrationUserData.name,
      //         role: this.addIntegrationUserData.role.hash
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'add_application_integration_user',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user: {
              name: this.addIntegrationUserData.name,
              role: this.addIntegrationUserData.role.hash
            }
          }
        })
        .then((response) => {
          if(response.status === 200) {
            response.json().then(responseData => {
              this.addIntegrationUserData.apiToken = responseData.data.token
              this.$vs.loading.close()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.operationPerformed'),
                text: this.$t('USER_INTEGRATION.dashboardAdded'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
            })
          } else if(response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async updateIntegrationUser() {

      if(!this.validateEditForm()) {
        return
      }

      this.$vs.loading({type: 'default'})

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'update_application_integration_user',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user: {
      //         hash: this.editIntegrationUserData.hash,
      //         name: this.editIntegrationUserData.name,
      //         role: this.editIntegrationUserData.role
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'update_application_integration_user',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user: {
              hash: this.editIntegrationUserData.hash,
              name: this.editIntegrationUserData.name,
              role: this.editIntegrationUserData.role
            }
          }
        })
        .then((response) => {
          if(response.status === 200) {
            this.getIntegrationUsers()
            this.editIntegrationUserPopUpActive = false
            this.clearEditForm()
            this.$vs.notify({
              title: this.$t('USER_INTEGRATION.operationPerformed'),
              text: this.$t('USER_INTEGRATION.dashboardUpdated'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if(response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async viewIntegrationUserDetail(userHash) {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_integration_user_detail',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user_hash: userHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'get_application_integration_user_detail',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user_hash: userHash
          }
        })
        .then((response) => {
          if(response.status === 200) {
            response.json().then((responseData) => {

            // this.viewDashboardData.name = responseData.dashboard.name
            // this.viewDashboardData.description = responseData.dashboard.description
            // this.viewDashboardData.roles = responseData.dashboard.roles
            // this.viewDashboardData.refreshInterval = this.refreshIntervalOptions.find(x => x.value === responseData.dashboard.refresh_interval)
            this.viewIntegrationUserData.name = responseData.user.name
            this.viewIntegrationUserData.role = responseData.user.role
            this.viewIntegrationUserData.apiToken = responseData.user.api_token

            this.viewIntegrationUserPopUpActive = true

            this.$vs.loading.close()
          })
            .catch(e => {
              console.log(e)
              this.$vs.loading.close()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.attention'),
                text: e.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              throw new Error(e.message)
            })
          } else if(response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getIntegrationUserDetail(userHash) {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_integration_user_detail',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user_hash: userHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'get_application_integration_user_detail',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user_hash: userHash
          }
        })
        .then((response) => {
          if(response.status === 200) {
            response.json().then((responseData) => {

            this.editIntegrationUserData.hash = responseData.user.hash
            this.editIntegrationUserData.name = responseData.user.name
            this.editIntegrationUserData.role = responseData.user.role

            this.editIntegrationUserPopUpActive = true

            this.$vs.loading.close()
          })
            .catch(e => {
              console.log(e)
              this.$vs.loading.close()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.attention'),
                text: e.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              throw new Error(e.message)
            })
          } else if(response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    confirmDeleteRecord (rowHash) {
      this.rowHashToDelete = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('USER_INTEGRATION.confirmDeletionTitle'),
        text: this.$t('USER_INTEGRATION.confirmDeletionText'),
        accept: this.deleteRecord,
        acceptText: this.$t('USER_INTEGRATION.delete')
      })
    },
    async deleteRecord () {

      this.$vs.loading({ type: 'default' })

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'delete_application_integration_user',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       dashboard_hash: this.rowHashToDelete
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
          command: 'delete_application_integration_user',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            dashboard_hash: this.rowHashToDelete
          }
        })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.getIntegrationUsers()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.operationPerformed'),
                text: this.$t('USER_INTEGRATION.userDeleted'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToDelete = ''
    },
    async getIntegrationUsersParameters() {
      this.$vs.loading({type: 'default'})
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_user_parameters',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'get_application_user_parameters',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
        .then((response) => {
          if(response.status === 200) {
            response.json().then((responseData) => {

            this.rolesOptions = []

            responseData.parameters.roles.forEach(item => {
              this.rolesOptions.push({
                hash: item.hash,
                name: item.name
              })
            })

            this.$vs.loading.close()
          })
            .catch(e => {
              console.log(e)
              this.$vs.loading.close()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.attention'),
                text: e.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              throw new Error(e.message)
            })
          } else if(response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getIntegrationUsers () {
      this.$vs.loading({type: 'default'})
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_integration_users',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'get_application_integration_users',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
        .then((response) => {
          if(response.status === 200) {
            response.json().then((responseData) => {

            this.integrationUsers = []

            if (responseData.users.length > 0) {
              responseData.users.forEach((item) => {

                const userRow = {
                  hash: item.hash,
                  name: item.name,
                  role: item.role,
                  api_token: item.api_token
                }

                this.integrationUsers.push(userRow)
              })
            }

            this.$vs.loading.close()
          })
            .catch(e => {
              console.log(e)
              this.$vs.loading.close()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.attention'),
                text: e.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              throw new Error(e.message)
            })
          } else if(response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    }
  },
  async created () {
    await this.getIntegrationUsersParameters()
    await this.getIntegrationUsers()
  }
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
